/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, ViewEncapsulation } from '@angular/core';
import { ToolsService } from 'src/app/services/tools.service';
import { NewChatBotComponent } from 'src/chatbot/chatbot.component';
import { dataChatService } from 'src/chatbot/service/dataChat.service';
import { ScrollService } from 'src/chatbot/service/scrollContainer.service';

@Component({
    selector: 'chat-bot-standalone',
    standalone: true,
    imports: [CommonModule ,NewChatBotComponent],
    templateUrl: './chat-bot-standalone.component.html',
    styleUrls: ['./chat-bot-standalone.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})

export class ChatBotStandaloneComponent {
    public chatID: InputSignal<string> = input.required<string>();  
    private scrollService = inject(ScrollService);
    public dataChatService = inject(dataChatService);
    public isFullScreen = computed(() => this.dataChatService.isFullScreen())
    public isStreaming = computed(() => this.dataChatService.isStreaming())

    public microIsActive = computed(() => this.dataChatService.microIsActive())

    public timeout: any;
    constructor(public tools: ToolsService) {}

    ngOnInit(){
        this.timeout = setTimeout(() => {
            this.dataChatService.showTooltip.set(true);
        }, 2500);
    }

    toggleChatView(){
        this.hideToolTip();
        this.dataChatService.hideChat.update(prev => !prev);
        if (!this.dataChatService.hideChat()){
            setTimeout(() => {
                this.scrollService.scrollToBottom();
            }, 50);
        }
    }

    hideToolTip(){
        if (this.timeout) 
            clearTimeout(this.timeout)
        
        this.dataChatService.showTooltip.set(false);
    }


}